import {
  AuthFlow,
  AuthFlowError,
  ChangePasswordErrorTypes,
} from '@griply/types';
import { getAuthErrorCode, mapChangePasswordError } from '@griply/utils';
import {
  EmailAuthProvider,
  reauthenticateWithCredential,
  updatePassword as authUpdatePassword,
} from 'firebase/auth';
import { getErrorReporter } from 'shared/services/error-tracking';

import { getAuthentication, reportAuthError } from './helpers';
import { notifyPasswordChanged } from './notify-password-changed';

export const updatePassword = async (
  oldPassword: string,
  newPassword: string,
) => {
  const auth = await getAuthentication();

  if (!auth.currentUser?.email) {
    const error = new AuthFlowError(ChangePasswordErrorTypes.Unknown);
    getErrorReporter().captureException(error, {
      tags: { source: 'update-password-no-email' },
    });
    throw error;
  }

  const credentials = EmailAuthProvider.credential(
    auth.currentUser.email,
    oldPassword,
  );

  try {
    await reauthenticateWithCredential(auth.currentUser, credentials);
    await authUpdatePassword(auth.currentUser, newPassword);
  } catch (e: unknown) {
    const kind = mapChangePasswordError(getAuthErrorCode(e));
    // Wrong / weak password are the user's to fix; anything else is a bug or
    // outage we need to hear about.
    if (kind === ChangePasswordErrorTypes.Unknown) {
      reportAuthError(e, AuthFlow.ChangePassword);
    }
    throw new AuthFlowError(kind, { cause: e });
  }

  void notifyPasswordChanged();
};
